// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aGts","controls":"styles_controls__6jq7g","charLimit":"styles_charLimit__3Cqpe","input":"styles_input__2qAox","send":"styles_send__3EqVi"};